import Vue from "vue";
import RecordsTable from "./RecordsTable/index.vue";
import DownloadingApp from "./DownloadingApp/index.vue";

export default Vue.extend({
  name: "ZoomInput",
  props: ["zoomRecords", "uploadedRecord", "isUploadFiles"],
  components: { RecordsTable, DownloadingApp },
});
